<template>
    <li>
        <div class="title d-flex justify-content-between">
            <div @click="action">
                <i class="fal fa-fw fa-envelope"></i>
                Predefined Response #1
            </div>

            <div>
                <i class="far fa-pencil" v-b-tooltip.hover title="Edit"></i>
                <i class="far fa-times-circle" v-b-tooltip.hover title="Delete"></i>
            </div>
        </div>

        <div class="subtitle">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
    </li>
</template>

<script>
    export default {
        name: 'SupportSettingsListItem',

        methods: {
            action: function () {
                this.$emit('action');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/variables';

    li {
        padding: 15px 20px 25px;
        border-bottom: 1px solid #e7e7e7;
        cursor: pointer;

        .title {
            font-size: 15px;
            font-weight: bold;
        }

        .subtitle {
            font-size: 12px;
            padding-left: 30px
        }

        .enrollment-progress {
            margin-top: 15px;
            color: #698ac2;

            .title {
                margin: 5px 0 3px;
                font-size: 11px;
                font-weight: bold;

                i {
                    margin-right: 3px;
                    color: #698ac2;
                }
            }
            .progress-bar {
                background-color: #3B84C2;
            }
        }

        i {
            font-size: $list-icon-size;
            margin-right: $list-icon-margin-right;
        }

        .details-button {
            font-size: 0.8rem;
            display: none;

            &:hover {
                color: #336699;
            }
        }

        &:hover {
            .details-button {
                display: block;
            }
        }

        &:hover {
            background-color: white;
        }

        &:last-child, &:only-child {
            border-bottom: none;
        }
    }
</style>
